<template>
  <template v-if="pageList == 'usermanagement'">
    <!-- 帳號管理 -->
    <userManagement></userManagement>
  </template>
  <template v-else-if="pageList == 'permissionsetting'">
    <!-- 權限設定 -->
    <permissionSetting></permissionSetting>
  </template>
</template>

<script>
import { useStore } from "vuex";
import { computed, onUnmounted, provide, ref, watch } from "@vue/runtime-core";
import userManagement from "@/components/permissionManagement/userManagement";
import permissionSetting from "@/components/permissionManagement/permissionSetting";
export default {
  components: {
    userManagement,
    permissionSetting,
  },
  setup() {
    const store = useStore();

    //getters
    const sideBarSelect = computed(
      () => store.getters["sideBarTree/get_sideBarSelect"]
    );

    const pageList = ref();

    //function
    const setSessionItems = () => {
      sessionStorage.setItem(
        "mes-permissionManagement-pageList",
        pageList.value
      );
    };
    window.addEventListener("beforeunload", setSessionItems);

    watch(sideBarSelect, (newValue) => {
      pageList.value = newValue.pageList;
    });

    setTimeout(() => {
      pageList.value = sideBarSelect.value.pageList;

      //session資料
      const mesPermissionManagementPageList = sessionStorage.getItem(
        "mes-permissionManagement-pageList"
      );
      sessionStorage.removeItem("mes-permissionManagement-pageList");
      if (mesPermissionManagementPageList != null) {
        pageList.value = mesPermissionManagementPageList;
      }
    }, 0);

    provide("pageList", pageList);

    onUnmounted(() => {
      window.removeEventListener("beforeunload", setSessionItems);
    });

    return { pageList };
  },
};
</script>

<style></style>
<style lang="scss"></style>
